import { createInjectionKey } from "../../_utils/index.mjs";
export const layoutSiderInjectionKey = createInjectionKey('n-layout-sider');
export const positionProp = {
  type: String,
  default: 'static'
};